import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import {
  LEAD_DELIVERY_LABELS,
  PARTNER_CATEGORIES,
  PARTNER_STATUSES,
  PARTNER_STATUS_LABELS,
  getCategoryLabel,
  statusBadgeClass,
} from "../../../constants/automapPartnershipConstants";
import { archivePartner, fetchPartners, fetchPartnersDashboard } from "../../../services/automapPartnershipApi";
import { AdminPartnersNav } from "./AdminPartnersShared";

export default function AdminPartnersListPage() {
  const [partners, setPartners] = useState([]);
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [deliveryMethod, setDeliveryMethod] = useState("");
  const [activeOnly, setActiveOnly] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [listRes, dashRes] = await Promise.all([
        fetchPartners({ category, status, city, deliveryMethod, activeOnly: activeOnly ? "true" : undefined }),
        fetchPartnersDashboard(),
      ]);
      const statsMap = Object.fromEntries((dashRes.dashboard?.partnersWithStats || []).map((p) => [p.id, p]));
      setPartners((listRes.partners || []).map((p) => ({ ...p, ...(statsMap[p.id] || {}) })));
      setDashboard(dashRes.dashboard);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [category, status, city, deliveryMethod, activeOnly]);

  useEffect(() => {
    load();
  }, [load]);

  const handleArchive = async (partnerId) => {
    if (!window.confirm("¿Archivar este aliado?")) return;
    await archivePartner(partnerId);
    load();
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Aliados"
        title="Partnerships"
        description="Aliados de servicios: financiación, seguro, SOAT, peritaje y traspaso."
        actions={<Link className="admin-link" to="/admin/partners/new">+ Agregar aliado</Link>}
      />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnersNav active="list" />
      <main className="admin-console__main wrap">
        {dashboard ? (
          <div className="admin-dashboard__metrics-grid" style={{ marginBottom: "1rem" }}>
            <div className="admin-dashboard__metric-card"><span className="admin-dashboard__metric-label">Leads esta semana</span><strong>{dashboard.partnerLeadsThisWeek}</strong></div>
            <div className="admin-dashboard__metric-card"><span className="admin-dashboard__metric-label">Aliados activos</span><strong>{dashboard.activePartners}</strong></div>
            <div className="admin-dashboard__metric-card"><span className="admin-dashboard__metric-label">Sin asignar</span><strong>{dashboard.unassignedPartnerLeads}</strong></div>
            <div className="admin-dashboard__metric-card"><span className="admin-dashboard__metric-label">Top categoría</span><strong>{dashboard.topCategory}</strong></div>
          </div>
        ) : null}
        <div className="dealer-inventory-toolbar">
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">Categoría</option>
            {PARTNER_CATEGORIES.map((c) => <option key={c} value={c}>{getCategoryLabel(c)}</option>)}
          </select>
          <select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">Estado</option>
            {PARTNER_STATUSES.map((s) => <option key={s} value={s}>{PARTNER_STATUS_LABELS[s]}</option>)}
          </select>
          <input placeholder="Ciudad" value={city} onChange={(e) => setCity(e.target.value)} />
          <select value={deliveryMethod} onChange={(e) => setDeliveryMethod(e.target.value)}>
            <option value="">Entrega</option>
            {Object.entries(LEAD_DELIVERY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <label><input type="checkbox" checked={activeOnly} onChange={(e) => setActiveOnly(e.target.checked)} /> Solo activos</label>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading ? (
          <div className="import-table-wrap">
            <table className="import-table">
              <thead>
                <tr>
                  <th>Aliado</th><th>Categoría</th><th>Estado</th><th>Ciudades</th><th>Prioridad</th><th>Entrega</th><th>Leads mes</th><th>Calificados</th><th>Conv.</th><th></th>
                </tr>
              </thead>
              <tbody>
                {partners.map((p) => (
                  <tr key={p.id}>
                    <td><Link to={`/admin/partners/${p.id}`}>{p.name}</Link></td>
                    <td>{getCategoryLabel(p.category)}</td>
                    <td><span className={statusBadgeClass(p.status)}>{PARTNER_STATUS_LABELS[p.status]}</span></td>
                    <td>{(p.citiesServed || []).slice(0, 2).join(", ") || "—"}</td>
                    <td>{p.routingPriority}</td>
                    <td>{LEAD_DELIVERY_LABELS[p.leadDeliveryMethod] || p.leadDeliveryMethod}</td>
                    <td>{p.leadsThisMonth ?? 0}</td>
                    <td>{p.qualifiedLeads ?? 0}</td>
                    <td>—</td>
                    <td><Link to={`/admin/partners/${p.id}`}>Abrir</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
